import React, { Component } from 'react';

const checks = require('../../images/checks.png');
const notCheckeds = require('../../images/notCheckeds.png');

export default class AntIconRadio extends Component {
    render() {
        const {
            selected = false,
            onChange,
            text
        } = this.props
        return (
            <div style={{ display: 'flex' }} onClick={onChange}>
                <img style={{ width: '14px', height: '14px', marginRight: '8px' }} src={selected ? checks : notCheckeds} /><div style={{ fontSize: 14, color: "#203152" }}>{text}</div>
            </div>
        );
    }
}


